import { Paper, Box, Typography } from "@mui/material";

type ContainerSectionProps = {
  children: React.ReactNode;
  label?: string;
};

export function ContainerSection({ children, label }: ContainerSectionProps) {
  return (
    <Paper
      elevation={2}
      sx={{
        position: "relative",
        padding: 2,
        marginY: 2,
        border: "1px solid",
        borderColor: "grey.200",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {label && (
        <Box
          sx={{
            position: "absolute",
            top: -10,
            left: 16,
            backgroundColor: "white",
            paddingX: 1,
          }}
        >
          <Typography variant="body2" color="textSecondary">
            {label}
          </Typography>
        </Box>
      )}

      {children}
    </Paper>
  );
}
